import NotFoundPage from "@/pages/NotFoundPage";
import { ConfigProvider } from "antd";
import { Outlet, Route, Routes } from "react-router-dom";
import "@/projects/FinEaseUser/styles/style.css";
import routes from "./utils/routes";
import FinEaseUserLayout from "./layouts/FinEaseUserLayout";
import { UserProtectedRoute } from "@/common/components/auth";

const FinEaseUserApp = () => {
  const authRoutes = routes.find(m => m.type === "auth")?.routes ?? [];

  return (
    <ConfigProvider
      theme={{
        hashed: false,
      }}
      componentSize="large"
    >
      <div className="fin-ease-user-app" style={{ height: "48px" }}>
        <Routes>
          {/* User-only protected routes */}
          <Route element={<UserProtectedRoute />}>
            <Route element={<FinEaseUserLayout />}>
              <Route element={<Outlet />}>
                {authRoutes.map(({ path, element: Page }) => (
                  <Route key={path} path={path} element={<Page />} />
                ))}
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </div>
    </ConfigProvider>
  );
};

export default FinEaseUserApp;
